// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentPageFooter_container__O2CwO"};